
import React, { Component } from "react";
import ReactDOM from 'react-dom';
import PropTypes from "prop-types";
import { bindActionCreators } from 'redux';
import {connect} from 'react-redux';
import * as loginActions from '../../actions/loginActions';
import * as kioskuserActions from '../../actions/kioskuserActions';
import {
    Grid,
    Row,
    Col,
    Image,
    FormGroup,
    FormControl,
    ControlLabel
} from "react-bootstrap";
//import "react-select/dist/react-select.css";
import Card from "../../components/Card/Card.jsx";
import SweetAlert from 'react-bootstrap-sweetalert';
import Button from "../../components/CustomButton/CustomButton.jsx";
import rest from "../../API/api";

class AddKioskuserForm extends Component {
    constructor(props) {
        super(props);
        this._grabUserInput = this._grabUserInput.bind(this);
        this._saveKioskuser = this._saveKioskuser.bind(this);
        this.isValidated = this.isValidated.bind(this);
        this.state = {
            Name: this.props.kioskuser.Name,
            Userid:  this.props.kioskuser.Userid,
            Hash: this.props.kioskuser.Hash,
            Salt: this.props.kioskuser.Salt,
            Password: this.props.kioskuser.Password,
            ConfirmPassword: this.props.kioskuser.ConfirmPassword,
            NameError: null,
            UseridError: null,
            PasswordError: null,
            ConfirmPasswordError: null
        }
    }
    static get contextTypes() {
        return {
            router: PropTypes.object
        };
    }

    isValidated() {
        //check each required field for validation
        var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        var passwordRequirementsEx = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})/;
        this.state.Name === ""
            ? this.setState({
                NameError: (
                    <small className="text-danger">
                        Please provide a name for this kiosk user.
                    </small>
                )
            })
            : this.setState({ NameError: null });
        var name = this.state.Name !== "";

        this.state.Userid === ""
            ? this.setState({
                UseridError: (
                    <small className="text-danger">
                        Please provide a User Id for this kiosk user.
                    </small>
                )
            })
            : this.setState({ UseridError: null });
        var ui = this.state.Userid !== "";

        this.state.Password === ""
            ? this.setState({
                PasswordError: (
                    <small className="text-danger">
                        Please provide a password for this kiosk user.
                    </small>
                )
            })
            : this.setState({ PasswordError: null });
        var password = this.state.Password !== "";

        this.state.ConfirmPassword === ""
            ? this.setState({
                ConfirmPasswordError: (
                    <small className="text-danger">
                        Please provide the password again for this kiosk kser.
                    </small>
                )
            })
            : this.setState({ ConfirmPasswordError: null });
        var confirm_password = this.state.ConfirmPassword !== "";

        passwordRequirementsEx.test(this.state.Password) === false
            ? this.setState({
                PasswordError: (
                    <small className="text-danger">
                        Password Requirements not met!.
                    </small>
                )
            })
            : this.setState({PasswordError: null});

        re.test(this.state.Userid) === false
            ? this.setState({
                UseridError: (
                    <small className="text-danger">
                        Userid must be formatted as an email address.
                    </small>
                )
            })
            : this.setState({UseridError: null});

        var valid = (name && ui && password && confirm_password) &&
            passwordRequirementsEx.test(this.state.Password) && re.test(this.state.Userid);
        if(valid)
            return valid;
    }

    passwordMismatchAlert(){
        this.setState({
                PasswordError: (
                    <small className="text-danger">
                        Password mismatch, please correct the passwords!
                    </small>
                ),
                ConfirmPasswordError: (
                    <small className="text-danger">
                        Password mismatch, please correct the passwords!
                    </small>
                )
            }
        );
    }

    duplicateUseridAlert(){
        this.setState({
                UseridError: (
                    <small className="text-danger">
                        Userid already exists!
                    </small>
                )
            }
        );
    }


    successAlert(saved){
        //Setup the alert and use the context to route to the Tenants once record is saved.
        if(saved) {
            this.setState({
                alert: (
                    <SweetAlert
                        success
                        title="Kiosk User added successfully!"
                        style={{display: "block"}}
                        onConfirm={() => this.context.router.history.push("/kioskusers")}
                        onCancel={() => this.context.router.history.push("/kioskusers")}
                        confirmBtnBsStyle="info"
                    >
                    </SweetAlert>
                )
            });
        }
        else
        {
            this.setState({
                alert: (
                    <SweetAlert
                        danger
                        style={{display: "block"}}
                        title="Error updating this Kiosk User record, Please try again!"
                        onConfirm={() => this.setState({alert: null})}
                        onCancel={() => this.setState({alert: null})}
                        confirmBtnBsStyle="danger"
                    >
                    </SweetAlert>
                )
            });
        }
    }

    _grabUserInput() {
        var crypto = require('crypto');
        //assign the Salt, generate the hash based on the password provided
        let mySalt = crypto.randomBytes(16).toString('hex');
        let myHash = crypto.pbkdf2Sync(document.getElementById('Password').value, mySalt, 1000, 64, 'sha512').toString('hex');
        return {
            Userid: document.getElementById('Userid').value,
            Name: document.getElementById('Name').value,
            Password: document.getElementById('Password').value,
            ConfirmPassword: document.getElementById('ConfirmPassword').value,
            Salt: mySalt,
            Hash: myHash
        };
    }

    async _saveKioskuser(event) {
        event.preventDefault();
        //Check to see of the userid exists, then check passwords and finally check rest of fields
        await fetch(rest.getKioskUserSalt, {
            method: 'POST',
            body: JSON.stringify({
                username: document.getElementById('Userid').value

            }),
            insecure: true,
            headers: new Headers({
                'Content-Type': 'application/json;charset=UTF-8',
                'x-api-key': rest.apiKey
            })
        })
            .then(response => response.json())
            .then(data => {
                //Check for duplicate User ID
                if (data.exist) {
                    //console.log(data);
                    this.duplicateUseridAlert();
                    return !(data.exist);
                } else {
                    this.setState({KioskidError: null});
                    //Check to see if the passwords match
                    if ((document.getElementById('Password').value) !== (document.getElementById('ConfirmPassword').value)) {
                        this.passwordMismatchAlert();
                        return;
                    }
                    //now check the rest of the fields if they are good write the record
                    if (this.isValidated()) {
                        //Call save tenant Thunk and pass it the current form values
                        let userInput = this._grabUserInput();
                        this.props.kioskuserActions.addKioskuser(this.props.userLoggedIn[0], userInput);
                        this.successAlert(true);
                    }
                }
            })
                        .catch(error => console.error(error));
    }


    render() {
        //debugger;
        if ((this.props.userLoggedIn[0].status) && (this.props.userLoggedIn[0].subscription)) {
            return (
                <div className="main-content" style={{ backgroundImage: "url(" + require("../../assets/img/matrix.jpg") + ")" }}>
                    <Grid fluid>
                        <Card
                            content={
                                <div>
                                    <legend>Add: Kiosk User Information</legend>
                                    <Row>
                                        <Col md={10} mdOffset={1}>
                                            <hr />
                                            <h6>User Ids should be formatted as an email address and must be unqiue to TRO.
                                                <br />All passwords must meet the following guidelines:<br />
                                                <ul>
                                                    <li>Password must contain at least 1 lowercase alphabetical character</li>
                                                    <li>Password must contain at least 1 uppercase alphabetical character</li>
                                                    <li>Password must contain at least 1 numeric character</li>
                                                    <li>Password must contain at least one special character</li>
                                                    <li>Password must be eight characters or longer</li>
                                                </ul>
                                            </h6>
                                            <hr />
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col md={5} mdOffset={1}>
                                            <FormGroup>
                                                <ControlLabel>Kiosk User Name <span className="text-danger">*</span></ControlLabel>
                                                <FormControl
                                                    id="Name"
                                                    type="text"
                                                    name="full_name"
                                                    placeholder="ex: John Doe"
                                                    value={this.state.Name}
                                                    onChange={event => this.setState({Name: event.target.value})}
                                                />
                                                {this.state.NameError}
                                            </FormGroup>
                                        </Col>
                                        <Col md={5}>
                                            <FormGroup>
                                                <ControlLabel>User Id </ControlLabel>
                                                <FormControl
                                                    id="Userid"
                                                    type="text"
                                                    name="userid"
                                                    placeholder="joe@joe.com"
                                                    value={this.state.Userid}
                                                    onChange={event => this.setState({Userid: event.target.value})}
                                                />
                                                {this.state.UseridError}
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col md={3} mdOffset={1}>
                                            <FormGroup>
                                                <ControlLabel>Password <span className="text-danger">*</span></ControlLabel>
                                                <FormControl
                                                    id="Password"
                                                    type="password"
                                                    name="password"
                                                    placeholder="ex: 1Swe456#@$"
                                                    value={this.state.Password}
                                                    onChange={event => this.setState({Password: event.target.value})}
                                                />
                                                {this.state.PasswordError}
                                            </FormGroup>
                                        </Col>
                                        <Col md={3}>
                                            <FormGroup>
                                                <ControlLabel>Confirm Password <span className="text-danger">*</span></ControlLabel>
                                                <FormControl
                                                    id="ConfirmPassword"
                                                    type="password"
                                                    name="confirm_password"
                                                    placeholder="ex: 1Swe456#@$"
                                                    value={this.state.ConfirmPassword}
                                                    onChange={event => this.setState({ConfirmPassword: event.target.value})}
                                                />
                                                {this.state.ConfirmPasswordError}
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col md={5} mdOffset={1} xs={5} xsOffset={1}>
                                            <Button bsStyle="info" pullRight fill wd onClick={this._saveKioskuser}>
                                                Save
                                            </Button>
                                        </Col>
                                        <Col md={1} mdOffset={1} xs={5} xsOffset={1}>
                                            <Button bsStyle="info" pullRight fill wd onClick={ async () => {
                                                let tURL = "/kioskusers";
                                                await this.context.router.history.push(tURL);
                                            }}>
                                                Cancel
                                            </Button>
                                        </Col>
                                    </Row>
                                </div>
                            }
                        />
                        {this.state.alert}
                    </Grid>
                </div>
            );
        }
        else {
            alert("You must be logged in and have an active subscription to access this page!");
            this.context.router.history.push("/pages/login-page");
            return(null);
        }
    }
}

AddKioskuserForm.propTypes = {
    loginActions: PropTypes.object.isRequired,
    userLoggedIn: PropTypes.array.isRequired,
    kioskuser: PropTypes.object.isRequired
};

function mapStateToProps(state, ownProps) {
    return {
        userLoggedIn: state.userLoggedIn,
        kioskuser: state.kioskuser
    };
}

function mapDispatchToProps(dispatch) {
    return {
        loginActions: bindActionCreators(loginActions, dispatch),
        kioskuserActions: bindActionCreators(kioskuserActions, dispatch)
    };
}
export default connect(mapStateToProps, mapDispatchToProps)(AddKioskuserForm);



// WEBPACK FOOTER //
// ./src/views/Forms/AddKioskUser.jsx